import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { history } from '../../history';
import { AlertAction } from '../../actions/AlertAction';
import { store } from '../../store';
import { AppHeader } from '../../components/common';
import ServiceCreateByErrorCode from '../../components/service/ServiceCreateByErrorCode';
import ServiceCreate from '../../components/service/ServiceCreate';
import { Translate as t } from '../../config/Translate';
import { getReferExtra } from '../../lib/serviceCreateRefer';

const ServiceAddNew = (props) => {

	// const [t, i18n] = useTranslation();

	const { refer, item, extraItem } = (props.location && props.location.state) || {};

	const callbackCreated = (service) => {
		if (!service?.ticketKey) {
			store.dispatch(AlertAction.ErrorMsg(t('service.message.createFailed') || 'Service creation failed. Please try again.'));
			return;
		}
		history.push('/Service/' + service.ticketKey);
	};

	return (
		<>
			<div className="appHeader no-border">
				<AppHeader title={t('service.button.addNew')} />
				<div className="right">
				</div>
			</div>
			<div id="appCapsule">
				{refer == "PRODUCTERROR" && (
					<ServiceCreateByErrorCode
						callbackCreated={callbackCreated}
						referErrorCode={item}
						referProduct={getReferExtra(refer, extraItem, "product")}
						referSite={getReferExtra(refer, extraItem, "site")}
					/>
				)}
				{refer != "PRODUCTERROR" && (
					<>
						<ServiceCreate
							sn={extraItem || ""}
							siteId={item || ""}
							callbackCreated={callbackCreated} />
					</>
				)}
			</div>
		</>
	);
};

export default ServiceAddNew;